export default {
  path: "/business",
  meta: {
    title: "旗下业务",
  },
  component: () => import("@/views/common/moduleMain.vue"),
  children: [
    {
      path: "/continuing/:menuId",
      meta: {
        title: "继续教育",
        contentType: "c-4",
        sortType: "s-203",
      },
      component: () => import("@/views/business/Continuing.vue"),
    },
    {
      path: "/vocational/:menuId",
      meta: {
        title: "职业教育",
        contentType: "c-4",
        sortType: "s-204",
      },
      component: () => import("@/views/business/Vocational.vue"),
    },
    {
      path: "/online/:menuId",
      meta: {
        title: "在线教育",
        contentType: "c-4",
        sortType: "s-205",
      },
      component: () => import("@/views/business/Online.vue"),
    },
  ],
};
